import ApiClient from "../ApiClient";

const ZoomServices = {

async exchangeCode(code) {
  const resp = await ApiClient.post("/zoom/oauth/token", { code });
  return resp.data.data; 
},

async refreshToken(refreshToken) {
    const resp = await ApiClient.post("/zoom/oauth/refresh", {
      refreshToken
    });
    return resp.data.data;
  },

async createUserMeeting(payload) {
  const auth = JSON.parse(localStorage.getItem("zoom_auth"));

  return ApiClient.post(
    "/zoom/user/meetings",
    payload,
    {
      headers: {
        "Zoom-Token": auth.access_token
      }
    }
  ).then(r => r.data.data);
},

  async updateUserMeeting(meetingId, payload) {
  const auth = JSON.parse(localStorage.getItem("zoom_auth"));

  return ApiClient.patch(
    `/zoom/user/meetings/${encodeURIComponent(meetingId)}`,
    payload,
    {
      headers: {
        "Zoom-Token": auth.access_token
      }
    }
  ).then(r => r.data.data);
},

  // Create instant or scheduled Zoom meeting
  async createMeeting(payload) {
    const resp = await ApiClient.post("/zoom/meetings", payload);
    return resp.data;
  },

  // Generate Zoom SDK signature
  async generateSignature(payload) {
    const resp = await ApiClient.post("/zoom/signature", payload);
    return resp.data;
  },

  // (future use) Get scheduled meetings
  async getUpcomingMeetings () {
    const resp = await ApiClient.get("/zoom/meetings/upcoming");
    return resp.data.data;
  },

  async deleteMeeting(meetingId, accessToken) {
    return ApiClient.delete(`/zoom/meetings/${meetingId}`, {
      headers: {
        "Zoom-Token": accessToken
      }
    })
    .then(r => r.data);
  },

  async deleteExpiredMeetings(accessToken) {
          return ApiClient.delete(`/zoom/meetings`, {
            headers: {
              "Zoom-Token": accessToken
            }
          }).then(r => r.data);
      },

};

export default ZoomServices;
